function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, chartTooltip, popoverActive) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'hidden': $helpers.isHidden(),
          'download-mode': $attr(`download-mode`)
        }, {
          'funnel-time-to-convert-chart': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.hasData() && $attr(`include-header`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'labels': true
              },
            }, (function() {
              var __jade_nodes = [];
              const subtitleText = $helpers.subtitleText();
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'description': true,
                  'mp-font-weight-medium': true
                },
              }, [__vjadeSafeCode(subtitleText.conversionText)]));
              __jade_nodes = __jade_nodes.concat(($helpers.isDrilledDown()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'conversion-percentage': true
                  },
                }, [__vjadeSafeCode(subtitleText.totalConversionPercentageText)]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!$helpers.hasData()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: 'empty-state'
              }),
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((popoverActive) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-actions-popover", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'open': popoverActive,
                  'title': $helpers.popover.popoverTitle(),
                  'button-options': JSON.stringify($helpers.popover.buttonOptions()),
                  'prevent-close-selectors': JSON.stringify(['.bar.hoverable']),
                  'cohort-names': $attr(`cohort-names`),
                  'cohort-details': JSON.stringify($helpers.popover.cohortDetails()),
                }),
                "style": $helpers.popover.getPopoverPlacement(),
                "on": {
                  action: $helpers.popover.handlePopoverAction,
                  close: $helpers.popover.closePopover,
                  cancelCohort: $helpers.popover.handleCancelCohort,
                  openCohortModal: $helpers.passThrough,
                },
                "class": {
                  'ttc': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'popover-content-wrapper': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'popover-content-icon': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'icon': `community`
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'popover-slot': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'popover-content-text-wrapper': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = ($helpers.popover.popoverBody());
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, content, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'popover-slot': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                const {
                                  count,
                                  percent,
                                  subText
                                } = content;
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'popover-content-text': true
                                  },
                                }, [__vjadeSafeCode(percent)]));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'popover-content-text': true
                                  },
                                }, [__vjadeSafeCode(count)]));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'popover-content-subtext': true
                                  },
                                }, [__vjadeSafeCode(subText)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var content = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'popover-slot': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    const {
                                      count,
                                      percent,
                                      subText
                                    } = content;
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'popover-content-text': true
                                      },
                                    }, [__vjadeSafeCode(percent)]));
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'popover-content-text': true
                                      },
                                    }, [__vjadeSafeCode(count)]));
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'popover-content-subtext': true
                                      },
                                    }, [__vjadeSafeCode(subText)]));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(($helpers.showBarChart()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'chart-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                const {
                  data,
                  isTruncated
                } = $helpers.barChartData();;
                __jade_nodes = __jade_nodes.concat(h("mp-funnels-bar-chart", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'disable-tooltip': popoverActive,
                    'display-relative': $attr(`value-representation`) === $helpers.ValueRepresentationType.Relative,
                  }),
                  "on": {
                    clickBar: $helpers.clickBar,
                    hoverBar: $helpers.hoverBar,
                    offHoverBar: $helpers.offHoverBar,
                    scroll: $helpers.popover.closePopover,
                  },
                  "props": {
                    data
                  },
                }));
                __jade_nodes = __jade_nodes.concat(($attr(`legend-sections`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-chart-legend", {
                    "attrs": __vjadeStringifyAttrsIfObj($helpers.chartLegendAttrs()),
                    "on": {
                      togglecheckbox: $helpers.passThrough,
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((chartTooltip) ? ((function() {
                  var __jade_nodes = [];
                  const {
                    color,
                    label,
                    sections,
                    isComparison,
                    left,
                    top
                  } = chartTooltip;;
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "style": {
                      left: `${left}px`,
                      top: `${top}px`,
                    },
                    "class": {
                      'hover-tooltip': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-chart-tooltip", {
                      "attrs": __vjadeStringifyAttrsIfObj($helpers.getChartToolTipAttrs(sections, color)),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((isTruncated) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'truncation-notice': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Results have been truncated to the first 30 results for download");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-legend-line-chart", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'display-analysis-type': `linear`,
                  'display-context': $attr(`display-context`),
                  'download-mode': $attr(`download-mode`),
                  'is-compact': $attr(`is-compact`),
                  'is-segmented': $helpers.isSegmented(),
                  'legend-sections': $attr(`legend-sections`),
                  'legend-theme': $attr(`legend-theme`),
                }),
                "on": {
                  togglecheckbox: $helpers.passThrough,
                },
                "props": {
                  chartData: $helpers.lineChartData(),
                  formatTooltip: $helpers.formatTooltip,
                  formatXAxisLabel: $helpers.formatXAxisLabel,
                  formatYAxisLabel: $helpers.formatYAxisLabel,
                  onHighChartClick: $helpers.lineChartClick,
                },
              }));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "chartTooltip" in locals ? locals.chartTooltip : typeof chartTooltip !== "undefined" ? chartTooltip : undefined, "popoverActive" in locals ? locals.popoverActive : typeof popoverActive !== "undefined" ? popoverActive : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;